<template>
  <section>
    <template v-if="this.$route.params.id == '1'">
      <article><img src="static/images/projection/geo3_end330-min.png" alt=""></article>
      <article><img src="static/images/projection/geo3_end331-min.png" alt=""></article>
    </template>
    <template v-if="this.$route.params.id == '2'">
      <article><img src="static/images/projection/geo3_end332-min.png" alt=""></article>
      <article><img src="static/images/projection/geo3_end333-min.png" alt=""></article>
    </template>
  </section>
</template>

<script>
import router from '@/router'
import cmd from '@/common/Command'

export default {
  mounted: function () {

    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-projection")
    $("body").addClass("page-projection-detail")
    cmd.adjustStyle()
  },
  methods: {
  },
  computed: {
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProjectionDetail.vue